import {Injectable} from '@angular/core';
import {Clipboard} from '@angular/cdk/clipboard';
import {AlertService} from './alert.service';
import {TranslateService} from '@ngx-translate/core';
import {PlatformService} from "./platform-service.service";
import {HttpClient, HttpHeaders, HttpUrlEncodingCodec} from "@angular/common/http";
import {Observable} from "rxjs";
import {LocalSettingsService} from "./local-settings.service";

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  SQLInjectionPattern: RegExp = /^[a-zA-Z\s\u00C0-\u017F-]+$/;

  constructor(
    private clipboard: Clipboard,
    private alertService: AlertService,
    private translate: TranslateService,
    private platformService: PlatformService,
    private http: HttpClient,
    private _localSettings: LocalSettingsService,
  ) {
  }

  removeAccent(name) {
    const accentMap = {
      'à': 'a', 'á': 'a', 'â': 'a', 'ä': 'a',
      'è': 'e', 'é': 'e', 'ê': 'e', 'ë': 'e',
      'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',
      'ò': 'o', 'ó': 'o', 'ô': 'o', 'ö': 'o',
      'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u',
      'ç': 'c',
      'ñ': 'n',
      'À': 'A', 'Á': 'A', 'Â': 'A', 'Ä': 'A',
      'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E',
      'Ì': 'I', 'Í': 'I', 'Î': 'I', 'Ï': 'I',
      'Ò': 'O', 'Ó': 'O', 'Ô': 'O', 'Ö': 'O',
      'Ù': 'U', 'Ú': 'U', 'Û': 'U', 'Ü': 'U',
      'Ç': 'C',
      'Ñ': 'N'
    };

    return name.replace(/[àáâäèéêëìíîïòóôöùúûüçñÀÁÂÄÈÉÊËÌÍÎÏÒÓÔÖÙÚÛÜÇÑ]/g, match => accentMap[match] || match);
  }

  slugify(name) {
    let nameResult = this.removeAccent(name)
    let nameLower = nameResult.toLowerCase()
    return nameLower
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  }

  public checkLatin(e) {
    const regex = new RegExp("^[A-zÀ-ÿ0-9- ']+$");
    return !regex.test(e.target.value);
  }

  public share(title, text, url) {
    if (this.platformService.isBrowserPlatform()) {
      if (navigator.share) {
        navigator.share({
          title: title,
          text: this.htmlToString(text),
          url: url
        })
      } else {
        this.copyToClipboard(url);
      }
    }
  }

  copyToClipboard(url) {
    this.clipboard.copy(url);
    if (this.translate.currentLang === 'fr') {
      this.alertService.openSnackBar('Le lien a bien été copié dans le presse-papiers', 'snack-success');
    } else {
      this.alertService.openSnackBar('The link has been copied to the clipboard', 'snack-success');
    }
  }

  htmlToString(content) {
    return content.replace(/<[^>]*>/g, '');
  }

  downloadPhoto(url: string): Observable<Blob> {
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET',
      'Access-Control-Allow-Headers': 'Content-Type'
    });

    return this.http.get(url, {headers, responseType: 'blob'});
  }


  async downloadFile(url) {
    const image = await fetch(url)
    const imageBlog = await image.blob()
    const imageURL = URL.createObjectURL(imageBlog)

    const link = document.createElement('a')
    link.href = imageURL
    link.download = 'image file name here'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  download(url: string): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob'
    })
  }

  extractIframeSrc(iframe: string) {
    const url = iframe.toString();
    const srcMatch = url.match(/src="([^"]+)"/);
    return srcMatch ? srcMatch[1] : null;
  }

  isValidInput(value) {
    return this.SQLInjectionPattern.test(value);
  }

  setUtmToHubspot(hubspotDatas) {
    const oldhubspotDatas = hubspotDatas;
    try {
      const utm = this._localSettings.getUtm();
      if (utm) {
        const utmUser = JSON.parse(utm);
        if (!Array.isArray(utmUser)) {
          return hubspotDatas;
        }

        let campaign = '';
        let source = '';
        let medium = '';

        utmUser.forEach(utmGroup => {
          utmGroup.forEach(({ key, value }) => {
            switch (key) {
              case 'utm_campaign':
                campaign = value;
                break;
              case 'utm_source':
                source = value;
                break;
              case 'utm_medium':
                medium = value;
                break;
            }
          });
        });


        campaign = Array.isArray(campaign) ? campaign[0] : campaign;
        source = Array.isArray(source) ? source[0] : source;
        medium = Array.isArray(medium) ? medium[0] : medium;

        hubspotDatas['campagne'] = campaign;
        hubspotDatas['source'] = source;
        hubspotDatas['medium'] = medium;

      }
    } catch (error) {
      delete oldhubspotDatas['campagne'];
      delete oldhubspotDatas['source'];
      delete oldhubspotDatas['medium'];

      return oldhubspotDatas;
    }
    return hubspotDatas;
  }

  encodeUrl(url: string){
    const codec = new HttpUrlEncodingCodec();
    return codec.encodeValue(url);
  }

  decodeUrl(url: string){
    const codec = new HttpUrlEncodingCodec();
    return codec.decodeValue(url);
  }

}
